(() => {
  const CONFIG = {
    'care-go-set': { bottle: 'Bottle Color', brush: 'Brush Color' },
    'calm-feeding-set': { 'slow-feeder': 'Slow Feeder Color', 'water-bowl': 'Water Bowl Color' },
    'walk-explore-set': { tracker: 'Tracker Color', bottle: 'Bottle Color', harness: 'Harness & Leash Color' }
  };

  const norm = value => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const currentHandle = () => {
    const match = location.pathname.match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  };
  const legendName = group => (group?.querySelector('legend')?.textContent || '').split(':')[0].trim();
  const findGroup = (root, label) => [...root.querySelectorAll('.pl-option, [data-option-position]')]
    .find(group => norm(legendName(group)) === norm(label));
  const swatchButtons = group => [...(group?.querySelectorAll('[data-option-value], [data-walk-value]') || [])];
  const buttonValue = button => button?.dataset.walkValue || button?.dataset.optionValue || '';
  const selectedButton = group => swatchButtons(group).find(button => button.classList.contains('is-selected')) || null;
  const labelNode = group => group?.querySelector('[data-option-label]') || group?.querySelector('legend strong') || null;

  const ensureStyles = () => {
    if (document.getElementById('pl-bundle-swatch-toggle-styles')) return;
    const style = document.createElement('style');
    style.id = 'pl-bundle-swatch-toggle-styles';
    style.textContent = `
      .pl-mix-item{display:none!important}
      .pl-mix-status{display:none!important}
      .pl-mix-group-off{opacity:1!important;filter:none!important}
      .pl-mix-group-off .pl-option__values{pointer-events:auto!important}
    `;
    document.head.appendChild(style);
  };

  const clearVisualSelection = item => {
    const active = selectedButton(item.group);
    if (active) item.lastValue = buttonValue(active) || item.lastValue;
    swatchButtons(item.group).forEach(button => {
      button.classList.remove('is-selected');
      button.setAttribute('aria-pressed', 'false');
    });
    item.group.dataset.bundleItemIncluded = 'false';
    const label = labelNode(item.group);
    if (label) label.textContent = '—';
  };

  const syncVisuals = items => {
    items.forEach(item => {
      if (!item.toggle.checked) {
        clearVisualSelection(item);
        return;
      }
      item.group.dataset.bundleItemIncluded = 'true';
      const active = selectedButton(item.group);
      if (!active) return;
      item.lastValue = buttonValue(active) || item.lastValue;
      const label = labelNode(item.group);
      if (label && buttonValue(active)) label.textContent = buttonValue(active);
    });
  };

  const buildItems = (root, config) => Object.entries(config).map(([key, groupLabel]) => {
    const row = root.querySelector(`[data-mix-component="${key}"]`);
    const toggle = row?.querySelector('input[type="checkbox"]');
    const group = findGroup(root, groupLabel);
    if (!row || !toggle || !group) return null;
    return { key, row, toggle, group, lastValue: buttonValue(selectedButton(group)) };
  }).filter(Boolean);

  const attach = (root, config) => {
    if (!root || root.dataset.bundleSwatchToggleReady === 'true') return false;
    const items = buildItems(root, config);
    if (items.length !== Object.keys(config).length) return false;

    root.dataset.bundleSwatchToggleReady = 'true';
    items.forEach(item => {
      item.row.hidden = true;
      item.row.setAttribute('aria-hidden', 'true');
      item.group.dataset.bundleItemIncluded = item.toggle.checked ? 'true' : 'false';
    });

    root.addEventListener('click', event => {
      const button = event.target.closest('[data-option-value], [data-walk-value]');
      if (!button || !root.contains(button)) return;
      const item = items.find(candidate => candidate.group.contains(button));
      if (!item) return;

      const isCurrent = button.classList.contains('is-selected');
      if (item.toggle.checked && isCurrent) {
        event.preventDefault();
        event.stopImmediatePropagation();
        item.lastValue = buttonValue(button) || item.lastValue;
        item.toggle.checked = false;
        clearVisualSelection(item);
        item.toggle.dispatchEvent(new Event('change', { bubbles: true }));
        button.blur?.();
        setTimeout(() => syncVisuals(items), 100);
        return;
      }

      if (!item.toggle.checked) {
        item.toggle.checked = true;
        item.group.dataset.bundleItemIncluded = 'true';
      }
      setTimeout(() => syncVisuals(items), 100);
    }, true);

    root.addEventListener('change', () => setTimeout(() => syncVisuals(items), 120), true);
    syncVisuals(items);
    return true;
  };

  const initRoot = root => {
    const config = CONFIG[currentHandle()];
    if (!config || !root || root.dataset.bundleSwatchToggleReady === 'true') return;
    let attempts = 0;
    const waitForBundleUi = () => {
      attempts += 1;
      if (attach(root, config)) return;
      if (attempts < 120) requestAnimationFrame(waitForBundleUi);
    };
    waitForBundleUi();
  };

  const boot = () => {
    ensureStyles();
    document.querySelectorAll('[data-powlife-product]').forEach(initRoot);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
